import React from "react";
var TableFormTrackerContext = React.createContext({
  formNames: [],
  pushFormName: function pushFormName() {},
  isActive: false
});
export default TableFormTrackerContext;